import { useFamilyMembers } from '../../api/hooks';

/**
 * FamilyMemberLegend - Compact color key showing family member colors
 *
 * Used by:
 * - Sidebar.tsx (at bottom of expanded sidebar)
 *
 * Design rationale:
 * - Compact horizontal layout to minimize vertical space
 * - Only shows in expanded sidebar (colors visible elsewhere)
 * - Helps users understand color coding in chore dots
 */
export function FamilyMemberLegend() {
  const { data: members, isLoading } = useFamilyMembers();

  if (isLoading || !members || members.length === 0) {
    return null;
  }

  return (
    <div className="family-member-legend lg:px-6 lg:py-4">
      {members.map((member) => (
        <div key={member.id} className="legend-item lg:gap-2" title={member.name}>
          <div
            className="legend-dot lg:w-4 lg:h-4"
            style={{ backgroundColor: member.color }}
          />
          <span className="legend-name lg:text-sm lg:max-w-none">{member.name}</span>
        </div>
      ))}
    </div>
  );
}
